<template>
    <!-- <v-container fluid class="mb-10 pb-10 px-0  py-0">
        <div class="">
            <v-container fluid class="px-5">
                <v-row cols="12" width="100%" wrap class="d-flex" align="center" justify="center">
                    <v-col cols="12" sm="8">
                        <strong>SUMMIT</strong> {{step.StepCategory}}
                    </v-col>
                    <v-col cols="12" sm="8">
                        <v-row>
                            <v-col cols="10">
                                Step {{step.StepOrder + 1}}
                                <h1>{{step.StepTitle}}</h1>
                            </v-col>
                            <v-col cols="2">
                                <q-compass-progress style="height:125px; width:125px;" :total-steps="step.StepsInCategory" :current-step="step.StepCategoryOrder"></q-compass-progress>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="8">
                        <slot></slot>
                    </v-col>
                    <v-col cols="12" sm="8">
                        <v-btn v-if="!step.Complete" color="primary" @click="$emit('checkrequirements')" block large>Complete Step</v-btn>
                        <v-btn v-if="step.PreviousStepUrl" :to="step.PreviousStepUrl">Previous Step</v-btn>
                        <v-btn v-if="step.OptionalInd" @click="$emit('skipstep')">Skip</v-btn>
                        <v-btn v-else-if="step.NextStepUrl && !step.CurrentStepInd && step.Complete" :to="step.NextStepUrl">Next Step</v-btn>
                    </v-col>
                    <v-col cols="12" sm="8">
                        <h3>Resources</h3>
                        <div v-html="step.StepConfig.content.block.Resources"></div>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </v-container> -->
    <QSummitStepLayout>
        <template #header>
            <QSummitStepHeader :title="step.StepCategory">
                <template #right>
                    <slot name="header-right" />
                </template>
            </QSummitStepHeader>
        </template>
        <template #footer>
            <QSummitStepResourcesFooter :html="step.StepConfig.content.block.Resources" :color="step.StepType" />
        </template>
        <QSummitStepBackground :color="step.StepType">
            <QSummitStepTitle :step="step" />
            <QSummitStepContainer>
                <div style="margin-bottom: 10rem;">
                    <QSummitStepContent v-for="(item, index) in content" :key="index">
                        <template v-if="item.video_id" #video>
                            <q-summit-wistia-player :video="item" />
                        </template>
                        <template v-if="!isNoText(item.text)" #text>
                            <h3 v-if="!isNoText(item.Title)" v-html="item.Title" />
                            <div v-if="!isNoText(item.text)" v-html="item.text" />
                        </template>
                        <template #controls v-if="index === content.length - 1">
                            <QSummitStepControls :step="step" @skipstep="$emit('skipstep')" @checkrequirements="$emit('checkrequirements')" />
                        </template>
                    </QSummitStepContent>
                </div>
            </QSummitStepContainer>
        </QSummitStepBackground>
    </QSummitStepLayout>
</template>
<script>
import QCompassProgress from "@/components/summit/QCompassProgress.vue";
import QSummitStepLayout from "../../components/summit/step-template/QSummitStepLayout.vue";
import QSummitStepResourcesFooter from "../../components/summit/step-template/QSummitStepResourcesFooter.vue";
import QSummitStepHeader from "../../components/summit/step-template/QSummitStepHeader.vue";
import QSummitStepBackground from "../../components/summit/step-template/QSummitStepBackground.vue";
import QSummitStepTitle from "../../components/summit/step-template/QSummitStepTitle.vue";
import QSummitStepContainer from "../../components/summit/step-template/QSummitStepContainer.vue";
import QSummitStepContent from "../../components/summit/step-template/content-templates/QSummitStepContent.vue";
import QSummitStepControls from "../../components/summit/step-template/QSummitStepControls.vue";
import QSummitWistiaPlayer from '@/CMS/views/ContentBlocks/Elements/QSummitWistiaPlayer.vue'

export default {
    props: {
        step: { type: Object, required: true },
    },

    computed: {
        videos() { return this.step.StepConfig.content.block.Videos },
        fullWidthText() { return this.step.StepConfig.content.block },

        content() {
            if (this.step.StepConfig.content.block.Videos) {
                return this.step.StepConfig.content.block.Videos
            }

            if (this.step.StepConfig.content.block.Title) {
                return [this.step.StepConfig.content.block]
            }
        }
    },

    methods: {
        isNoText(text) {
            return !text || text === '<p></p>'
        }
    },

    components: {
        QCompassProgress,
        QSummitStepLayout,
        QSummitStepResourcesFooter,
        QSummitStepHeader,
        QSummitStepBackground,
        QSummitStepTitle,
        QSummitStepContainer,
        QSummitStepContent,
        QSummitStepControls,
        QSummitWistiaPlayer
    },
}
</script>